// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.personalInfo-logo{
    width: 40px;
height: 40px


}
.mainInfoCont{
    background-color: white !important;
    /* width:100%; */
    padding: 20px;
    margin: 0 auto;
    /* margin-right: 2% !important; */
    border-radius: 10px;
}

.acc-title{
    align-self: center;
    font-family: "Inter";
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
    letter-spacing: 0.02em;
    text-align: left;
    
color:#00162E !important

}
.label{
    font-family: "Inter";
font-size: 16px;
font-weight: 550;
line-height: 19px;
letter-spacing: 0.02em;
text-align: left;
color:#0056B2;
padding-left: 10px;
padding-bottom: 5px;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;



}


.resetChanges{
    width:  163px !important;
height:  39px !important;

border-radius: 3px !important;
background-color:#E5F0FC !important;
font-family: "Inter" !important;
font-size: 16px !important;
font-weight: 600 !important;
line-height: 19px !important;
letter-spacing: 0.02em !important;
text-align: center !important;
color: #375370 !important;
text-transform: capitalize !important;


}

.cancelButton{
    width: 97px !important ;
height: 39px !important;

border-radius: 3px;
border: 1px solid #FE602F !important;
color:#FE602F !important;
font-family: "Inter" !important;
font-size: 16px !important;
font-weight: 600 !important;
line-height: 19px !important;
letter-spacing: 0.02em !important;
text-align: center !important;
text-transform: capitalize !important;

}
.saveButton{
    width: 80px !important;
height: 39px !important;
/* padding: 10px, 20px, 10px, 20px */
border-radius: 3px !important;
background-color: #FE602F !important;
color: #FFFFFF !important;
font-family: "Inter" !important;
font-size: 16px !important;
font-weight: 600 !important;
line-height: 19px !important;
letter-spacing: 0.02em !important;
text-align: center !important;
text-transform: capitalize !important;

}

.Accordianicon{
    width: 6px;
height: 12px;
color:#0056B2 !important;
font-size: 40px !important;

}
  
  
.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input{
    width: 100% !important;
 

}

.subHeadingforinfos{
    font-family: "Inter";
font-size: 16px;
font-weight: 700;
line-height: 19px;
letter-spacing: 0.02em;
text-align: left;
color:#002C5D

}



.addSectionButton{
    background-color: hsl(14, 99%, 59%) !important;
    color: white !important;
    text-transform: capitalize;

}
.removeSectionButton{
    background-color: #FE602F !important;
    color: white !important;
    text-transform: capitalize;
    
}
.error-msg{
    color:red;
}
.error-message{
    color:red
}

.prev-exp-parent {
    text-align: right;
    margin: 20px 0px;
}

.prev-exp-btn {
    background-color: hsl(14, 99%, 59%) !important;
    color: white !important;
    text-transform: capitalize !important;
    font-weight: bold;
}

.prev-exp-rem-btn{
    color: #FFFFFF;
    background-color: red;
    cursor: pointer;
    border:none;
    border-radius: 22px;
    padding: 5px 10px;
    margin: 0px 10px;
    font-weight: bold;
}
 `, "",{"version":3,"sources":["webpack://./src/views/panel/addEmployee/AddEmployee.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;;AAGA;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;;AAEpB;;AAEA;AACA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,sBAAsB;AACtB,gBAAgB;AAChB,aAAa;AACb,kBAAkB;AAClB,mBAAmB;AACnB,mBAAmB;AACnB,gBAAgB;AAChB,uBAAuB;;;;AAIvB;;;AAGA;IACI,wBAAwB;AAC5B,wBAAwB;;AAExB,6BAA6B;AAC7B,mCAAmC;AACnC,+BAA+B;AAC/B,0BAA0B;AAC1B,2BAA2B;AAC3B,4BAA4B;AAC5B,iCAAiC;AACjC,6BAA6B;AAC7B,yBAAyB;AACzB,qCAAqC;;;AAGrC;;AAEA;IACI,uBAAuB;AAC3B,uBAAuB;;AAEvB,kBAAkB;AAClB,oCAAoC;AACpC,wBAAwB;AACxB,+BAA+B;AAC/B,0BAA0B;AAC1B,2BAA2B;AAC3B,4BAA4B;AAC5B,iCAAiC;AACjC,6BAA6B;AAC7B,qCAAqC;;AAErC;AACA;IACI,sBAAsB;AAC1B,uBAAuB;AACvB,oCAAoC;AACpC,6BAA6B;AAC7B,oCAAoC;AACpC,yBAAyB;AACzB,+BAA+B;AAC/B,0BAA0B;AAC1B,2BAA2B;AAC3B,4BAA4B;AAC5B,iCAAiC;AACjC,6BAA6B;AAC7B,qCAAqC;;AAErC;;AAEA;IACI,UAAU;AACd,YAAY;AACZ,wBAAwB;AACxB,0BAA0B;;AAE1B;;;AAGA;IACI,sBAAsB;;;AAG1B;;AAEA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,sBAAsB;AACtB,gBAAgB;AAChB;;AAEA;;;;AAIA;IACI,8CAA8C;IAC9C,uBAAuB;IACvB,0BAA0B;;AAE9B;AACA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,0BAA0B;;AAE9B;AACA;IACI,SAAS;AACb;AACA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,8CAA8C;IAC9C,uBAAuB;IACvB,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".personalInfo-logo{\r\n    width: 40px;\r\nheight: 40px\r\n\r\n\r\n}\r\n.mainInfoCont{\r\n    background-color: white !important;\r\n    /* width:100%; */\r\n    padding: 20px;\r\n    margin: 0 auto;\r\n    /* margin-right: 2% !important; */\r\n    border-radius: 10px;\r\n}\r\n\r\n.acc-title{\r\n    align-self: center;\r\n    font-family: \"Inter\";\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    line-height: 19px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    \r\ncolor:#00162E !important\r\n\r\n}\r\n.label{\r\n    font-family: \"Inter\";\r\nfont-size: 16px;\r\nfont-weight: 550;\r\nline-height: 19px;\r\nletter-spacing: 0.02em;\r\ntext-align: left;\r\ncolor:#0056B2;\r\npadding-left: 10px;\r\npadding-bottom: 5px;\r\nwhite-space: nowrap;\r\noverflow: hidden;\r\ntext-overflow: ellipsis;\r\n\r\n\r\n\r\n}\r\n\r\n\r\n.resetChanges{\r\n    width:  163px !important;\r\nheight:  39px !important;\r\n\r\nborder-radius: 3px !important;\r\nbackground-color:#E5F0FC !important;\r\nfont-family: \"Inter\" !important;\r\nfont-size: 16px !important;\r\nfont-weight: 600 !important;\r\nline-height: 19px !important;\r\nletter-spacing: 0.02em !important;\r\ntext-align: center !important;\r\ncolor: #375370 !important;\r\ntext-transform: capitalize !important;\r\n\r\n\r\n}\r\n\r\n.cancelButton{\r\n    width: 97px !important ;\r\nheight: 39px !important;\r\n\r\nborder-radius: 3px;\r\nborder: 1px solid #FE602F !important;\r\ncolor:#FE602F !important;\r\nfont-family: \"Inter\" !important;\r\nfont-size: 16px !important;\r\nfont-weight: 600 !important;\r\nline-height: 19px !important;\r\nletter-spacing: 0.02em !important;\r\ntext-align: center !important;\r\ntext-transform: capitalize !important;\r\n\r\n}\r\n.saveButton{\r\n    width: 80px !important;\r\nheight: 39px !important;\r\n/* padding: 10px, 20px, 10px, 20px */\r\nborder-radius: 3px !important;\r\nbackground-color: #FE602F !important;\r\ncolor: #FFFFFF !important;\r\nfont-family: \"Inter\" !important;\r\nfont-size: 16px !important;\r\nfont-weight: 600 !important;\r\nline-height: 19px !important;\r\nletter-spacing: 0.02em !important;\r\ntext-align: center !important;\r\ntext-transform: capitalize !important;\r\n\r\n}\r\n\r\n.Accordianicon{\r\n    width: 6px;\r\nheight: 12px;\r\ncolor:#0056B2 !important;\r\nfont-size: 40px !important;\r\n\r\n}\r\n  \r\n  \r\n.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input{\r\n    width: 100% !important;\r\n \r\n\r\n}\r\n\r\n.subHeadingforinfos{\r\n    font-family: \"Inter\";\r\nfont-size: 16px;\r\nfont-weight: 700;\r\nline-height: 19px;\r\nletter-spacing: 0.02em;\r\ntext-align: left;\r\ncolor:#002C5D\r\n\r\n}\r\n\r\n\r\n\r\n.addSectionButton{\r\n    background-color: hsl(14, 99%, 59%) !important;\r\n    color: white !important;\r\n    text-transform: capitalize;\r\n\r\n}\r\n.removeSectionButton{\r\n    background-color: #FE602F !important;\r\n    color: white !important;\r\n    text-transform: capitalize;\r\n    \r\n}\r\n.error-msg{\r\n    color:red;\r\n}\r\n.error-message{\r\n    color:red\r\n}\r\n\r\n.prev-exp-parent {\r\n    text-align: right;\r\n    margin: 20px 0px;\r\n}\r\n\r\n.prev-exp-btn {\r\n    background-color: hsl(14, 99%, 59%) !important;\r\n    color: white !important;\r\n    text-transform: capitalize !important;\r\n    font-weight: bold;\r\n}\r\n\r\n.prev-exp-rem-btn{\r\n    color: #FFFFFF;\r\n    background-color: red;\r\n    cursor: pointer;\r\n    border:none;\r\n    border-radius: 22px;\r\n    padding: 5px 10px;\r\n    margin: 0px 10px;\r\n    font-weight: bold;\r\n}\r\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
